import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { articleOnClickHandler } from '../../app/appActions';
import {
  alchemyThemeSelector,
  getCorrelationId,
  isAmcSelector,
  isDarkThemeSelector,
  isGetHelpSelector,
  isSignUpSelector,
  isTeamsSelector,
  recommendationModalitySelector,
  showGetCurrentMessageBarBoxOnModalityPage,
} from '../../app/selectors/contactUsSelector';
import { ModalityOptions } from '../presentationalComponents/ModalityOptions';
import { updateDraftRequest } from '../reduxUpdater/actions/modalitySectionActions';
import { dispatchFetchAvailableModalitiesV2 } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getContactUsStyles } from '../styles/contactUsStyles';
import { dispatchUpdateShowAgentModalitiesButton } from '../reduxUpdater/dispatchers/requestDispatchers';
import { showAgentModalitiesButtonClickedSelector } from '../reduxUpdater/selectors/commonSelectors';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isGettingAvailableModalities: state.ContactState.ModalitySectionState.isGettingAvailableModalities,
    modalityResponse: state.ContactState.ModalitySectionState.modalityResponse,
    isGetHelp: isGetHelpSelector(state),
    isSignUp: isSignUpSelector(state),
    isDarkTheme: isDarkThemeSelector(state),
    isAmc: isAmcSelector(state),
    isAMCModalityEnabled: state.ContactState.ModalitySectionState.isAMCModalityEnabled,
    alchemyTheme: alchemyThemeSelector(state),
    showGetCurrentBox: showGetCurrentMessageBarBoxOnModalityPage(state),
    recommendationModality: recommendationModalitySelector(state),
    request: state.ContactState.ModalitySectionState.createdRequest,
    showAgentModalitiesButtonClicked: showAgentModalitiesButtonClickedSelector(state),
    correlationId: getCorrelationId(state),
    isTeams: isTeamsSelector(state),
  };
};

const mapDispatchToProps = {
  dispatchFetchAvailableModalitiesV2,
  updateDraftRequest,
  articleOnClickHandler,
  dispatchUpdateShowAgentModalitiesButton,
};

export const ModalityOptionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ModalityOptions, getContactUsStyles));
